export const TELESALES_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },
  { slug: 'link', name: 'Leaderboard', href: '/leaderboard', icon: 'cilCup' },

  { slug: 'title', name: 'Order Forms' },
  { slug: 'link', name: 'Tele Sales', href: '/telesales', icon: 'cilPhone' },

  { slug: 'title', name: 'MAP Utilities' },
  { slug: 'link', name: 'Customers', href: '/telesales-customers', icon: 'cilUser' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'Call Queue', href: '/callqueue', icon: 'cilCallOutgoing' },
  { slug: 'link', name: 'My Call Summary', href: '/my_call_summary', icon: 'cilChartBar' },
  { slug: 'link', name: 'Graded Follow Ups', href: '/grade_followups', icon: 'cilStar' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
